import EventBus, { EVENTS } from '../eventBus';
import type { EditDialogProps, EditDialogRequest } from './editDialogRequest';
import type { BaseDialogProps } from './types';
import { createReactiveDialogRequest } from './requestDialog';

/**
 * Show a dialog to edit the given string.
 * @param dialogProps The base dialog props to configure the dialog
 * @param editDialogProps Props for the editing experience
 * @param actionFn The callback to call when the user confirms their change
 */
export async function showEditDialog(
  dialogProps: BaseDialogProps,
  editDialogProps: EditDialogProps,
  actionFn: (val: string) => Promise<any>,
  bootstrappingFn?: () => Promise<any>,
) {
  const req = createReactiveDialogRequest<EditDialogRequest>({
    bootstrapping: bootstrappingFn !== undefined,
    loading: false,
    showDialog: true,
    dialogProps,
    editDialogProps,
    callback: response => {
      async function run() {
        req.loading = true;
        await actionFn(response);
        req.loading = false;
        req.showDialog = false;
      }
      run().catch(ex => console.error('showEditDialog callback', ex));
    }
  });
  showEditDialogFromRequest(req);
  if (bootstrappingFn) {
    await bootstrappingFn();
    req.bootstrapping = false;
  }
}

export function showEditDialogFromRequest(req: EditDialogRequest) {
  EventBus.emit(EVENTS.SHOW_DIALOG, {
    type: 'edit',
    req,
  });
}
